export enum SWITCHER {
  PARTNER_PORTAL = 'Partner Portal',
  PARTNER_SUPPORT = 'Partner Service Desk',
  RESOURCE_HUB = 'Resource Hub',
}

export enum NAVIGATION_TYPE {
  NAVIGATION_LINK = 'NavigationLink',
  NAVIGATION_GROUP = 'NavigationGroup',
}
